import React, { useState } from 'react';
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import DashboardReportAllocationPage from './DashboardReportAllocationPage'; // Import the report allocation component

const SettingsPage = () => {
  const { path, url } = useRouteMatch();
  const [activeSection, setActiveSection] = useState('organization-profile'); // Set default section

  return (
    <div className="settings-container">
      <h2>Settings</h2>
      <nav>
        <ul>
          <li className={activeSection === 'org-profile' ? 'active' : ''}>
            <Link to={"/organization-profile"} onClick={() => setActiveSection('org-profile')}>
              Org Profile
            </Link>
          </li>
          <li className={activeSection === 'Dashboard-report-allocation' ? 'active' : ''}>
            <Link to={`${url}/report-allocation`} onClick={() => setActiveSection('report-allocation')}>
              Dashboard Report Allocation
            </Link>
          </li>
          <li className={activeSection === 'User-report-allocation' ? 'active' : ''}>
            <Link to={"/reports-allocation"} onClick={() => setActiveSection('report-allocation')}>
              User Report Allocation
            </Link>
          </li>
          <li className={activeSection === 'report-management' ? 'active' : ''}>
            <Link to={"/access-manage-reports"} onClick={() => setActiveSection('report-management')}>
              Report Management
            </Link>
          </li>
          <li className={activeSection === 'manage-subscriptions' ? 'active' : ''}>
            <Link to={"/manage-subscriptions"} onClick={() => setActiveSection('manage-subscriptions')}>
              Subscription Management
            </Link>
          </li>
          <li className={activeSection === 'user-management' ? 'active' : ''}>
            <Link to={"/manage-users"} onClick={() => setActiveSection('user-management')}>
              User Management
            </Link>
          </li>
        </ul>
      </nav>

      <Switch>
        <Route path={`${path}/org-profile`}>
          <div>Org Profile Section</div>
        </Route>
        <Route path={`${path}/report-allocation`}>
          <DashboardReportAllocationPage /> {/* Render the report allocation component here */}
        </Route>
        <Route path={`${path}/report-management`}>
          <div>Report Management Section</div>
        </Route>
        <Route path={`${path}/manage-subscriptions`}>
          <div>Subscription Management Section</div>
        </Route>
        <Route path={`${path}/user-management`}>
          <div>User Management Section</div>
        </Route>
      </Switch>
    </div>
  );
};

export default SettingsPage;
